import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Container = styled.div`
    width: 100%;
`;

export const ServiceWrap = styled.div`
    width: 100%;
    justify-content: space-between;

    @media (max-width: ${wideBreakpoints.mobile}) {
        align-items: flex-end;
    }
`;

export const PriceWrap = styled.div`
    gap: 16px;

    @media (max-width: 400px) {
        flex-direction: column-reverse;
        gap: 0;
    }
`;

export const Service = styled.span`
    ${FONTS.H5};
    color: ${COLORS.GRAY_S};

    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 120px;
    }
`;

export const ServiceConnect = styled.span`
    ${FONTS.H4};
    color: ${COLORS.white};

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.H5};
        width: 120px;
    }
`;

export const Price = styled.span`
    ${FONTS.S};
    color: ${COLORS.GRAY_S};
`;

export const PriceConnect = styled.span`
    ${FONTS.H3};
    color: ${COLORS.white};
    
    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.H5};
    }
`;

export const OldPrice = styled.s`
    ${FONTS.H3};
    color: ${COLORS.GRAY_S};
    
    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.H5};
    }
`;
